module.exports = __webpack_public_path__ + "img/Employee-1.7badde5c.png";